<template>
    <div class="recharge-container">
        <div class="content-wrapper">
            <div class="qr-box">
                <van-image width="200" height="200"
                    src="https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=TUSThMaYENZk3isyyfZeUh1vVB1v8pxoC5" />
            </div>

            <div class="address-section">
                <div class="label">USDT Recharge Address</div>
                <van-field v-model="address" readonly class="custom-field" :border="false">
                    <template #button>
                        <van-button size="small" type="primary" class="copy-btn" @click="onCopy">
                            Copy
                        </van-button>
                    </template>
                </van-field>
            </div>

            <div class="info-grid">
                <div class="info-item">
                    <span class="info-label">Mainnet</span>
                    <span class="info-value">Tron (TRC20)</span>
                </div>
                <div class="info-item text-right">
                    <span class="info-label">Charging Range</span>
                    <span class="info-value highlight">10 - 20 USDT</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { showToast } from 'vant';
import 'vant/es/toast/style';

const address = ref('TUSThMaYENZk3isyyfZeUh1vVB1v8pxoC5');

const onCopy = () => {
    navigator.clipboard.writeText(address.value);
    showToast('Address Copied');
};
</script>

<style scoped>
.recharge-container {
    background-color: #0a0a0a6a;
    color: white;
    display: flex;
    justify-content: center;
    padding: 5%;
    margin: 0 5%;
    border-radius: 10px;
}

.content-wrapper {
    width: 100%;
    max-width: 350px;
}

.qr-box {
    background: white;
    padding: 20px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
}

.address-section .label {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 10px;
}

/* Customizing Vant Field to match dark theme */
.custom-field {
    background-color: #000 !important;
    border: 1px solid #333;
    border-radius: 8px;
    padding: 0 0 0 5%;
}

.custom-field :deep(.van-field__control) {
    color: #fff;
    font-family: monospace;
    font-size: 12px;
}

.copy-btn {
    background-color: #fda766;
    border: none;
    height: 36px;
    padding: 0 20px;
    border-radius: 6px;
}

.info-grid {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
}

.info-item {
    display: flex;
    flex-direction: column;
}

.info-label {
    color: #888;
    font-size: 12px;
    margin-bottom: 4px;
}

.info-value {
    font-weight: bold;
    font-size: 14px;
}

.highlight {
    color: #eed29f;
}

.text-right {
    text-align: right;
}
</style>